
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/reports",
      function () {
        return require("private-next-pages/team/reports.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/reports"])
      });
    }
  